/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1DocumentCourseEnrollmentDocument200,
  DeleteApiV1DocumentCourseEnrollmentDocument401,
  DeleteApiV1DocumentCourseEnrollmentDocument500,
  DeleteApiV1DocumentCourseEnrollmentDocumentMutationResponse,
  DeleteApiV1DocumentCourseEnrollmentDocumentQueryParams,
} from "../../types/documentCourseController/DeleteApiV1DocumentCourseEnrollmentDocument.ts";

export const deleteApiV1DocumentCourseEnrollmentDocumentQueryParamsSchema = z
  .object({
    courseId: z.optional(z.coerce.number().int()),
    enrollmentDocumentId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<DeleteApiV1DocumentCourseEnrollmentDocumentQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1DocumentCourseEnrollmentDocument200Schema =
  z.any() as unknown as ToZod<DeleteApiV1DocumentCourseEnrollmentDocument200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1DocumentCourseEnrollmentDocument401Schema =
  z.any() as unknown as ToZod<DeleteApiV1DocumentCourseEnrollmentDocument401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1DocumentCourseEnrollmentDocument500Schema =
  z.any() as unknown as ToZod<DeleteApiV1DocumentCourseEnrollmentDocument500>;

export const deleteApiV1DocumentCourseEnrollmentDocumentMutationResponseSchema =
  z.lazy(
    () => deleteApiV1DocumentCourseEnrollmentDocument200Schema,
  ) as unknown as ToZod<DeleteApiV1DocumentCourseEnrollmentDocumentMutationResponse>;
